









































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  GetHospitals,
  PostFuwugailanJigouzongti,
  PostFuwugailanYuequshi,
} from "@/request/hdr";
import Copy from "@/components/copy.vue";
import Fuwurenci from "./fuwurenci.vue";
import Gailan from "./gailan.vue";
import Neirong from "./neirong.vue";
import Renkou from "./renkou.vue";
import HospitalTransfer from "../hospital-transfer.vue";
@Component({
  components: {
    Copy,
    Fuwurenci,
    Gailan,
    Neirong,
    Renkou,
    HospitalTransfer,
  },
})
export default class KanbanZhiweibing extends Vue {
  private hospitals: any[] = [];
  private canChooseHospitals: any[] = [];
  private ifShowHospitalTransfer: boolean = false;
  private selectedHospitals: any[] = [];
  private loaded: boolean = false;

  private get selectedHospitalLabels() {
    if (this.selectedHospitals.length === 0) {
      return "全部机构";
    } else {
      const labels: any[] = [];
      this.selectedHospitals.forEach((h: any) => {
        labels.push(h["医院名称"]);
      });
      return labels.join("，");
    }
  }
  /**
   * @description 跳转数据大屏
   */
  private jumpDapin() {
    this.$router.push({
      path: "/main/sjzx/kanban-daping",
    });
  }
  /**
   * @description 获取可选医院列表
   */
  private fetchHospitals() {
    const load = this.$loading({ text: "加载中" });
    return new Promise((resolve: any) => {
      GetHospitals(this).then((data: any) => {
        this.canChooseHospitals = data;
        load.close();
        resolve();
      });
    });
  }
  /**
   * @description 重置
   */
  private reset() {
    this.selectedHospitals = [];
  }
  /**
   * @description 统计机构改变
   */
  private hospitalChanged(ids) {
    this.selectedHospitals = [];
    ids.forEach((id: any) => {
      const targetHospital = this.canChooseHospitals.find((h: any) => {
        return h.hospital_id === id;
      });
      if (targetHospital) {
        this.selectedHospitals.push(targetHospital);
      }
    });
  }

  /**
   * @description 全部统计
   */
  private analysis() {
    (this.$refs.gailan as any).fuwugailanJigouzongti();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchHospitals().then(() => {
      this.loaded = true;
    });
  }
}
